document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-menu-toggle]');
  if (toggle) {
    const header = toggle.closest('.site-header');
    const open = header.classList.toggle('menu-open');
    toggle.setAttribute('aria-expanded', String(open));
  }

  const accordion = event.target.closest('[data-accordion-trigger]');
  if (accordion) {
    const item = accordion.closest('.accordion-item');
    const open = item.classList.toggle('is-open');
    accordion.setAttribute('aria-expanded', String(open));
  }
});

document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-product-variant-select]');
  if (!select) return;
  const option = select.options[select.selectedIndex];
  const product = select.closest('[data-product-root]');
  const idInput = product?.querySelector('input[name="id"]');
  const price = product?.querySelector('[data-product-price]');
  const button = product?.querySelector('[data-add-to-cart]');
  if (idInput) idInput.value = option.value;
  if (price && option.dataset.price) price.textContent = option.dataset.price;
  if (button) {
    button.disabled = option.disabled;
    button.textContent = option.disabled ? 'Sold out' : 'Add to bag';
  }
  const accelerated = product?.querySelector('.product-form__accelerated');
  if (accelerated) accelerated.hidden = option.disabled;
});

const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

function initialiseMotion() {
  const revealGroups = [
    ['.value-strip__grid', '.value'],
    ['.collection-grid', '.collection-tile'],
    ['.product-grid', '.product-card'],
    ['.story-grid', '.story-visual, .story-copy'],
    ['.intention-grid', '.intention-card'],
    ['.journal-grid', '.journal-card'],
    ['.newsletter', ':scope > *'],
    ['.footer-grid', ':scope > *'],
    ['.product-layout', ':scope > *'],
    ['.product-trust', '.trust-card'],
    ['.product-accordions', '.accordion-item'],
    ['.cart-table tbody', 'tr'],
    ['.narrative-grid', '.narrative-image, .narrative-content']
  ];
  const revealItems = new Set();

  revealGroups.forEach(([parentSelector, itemSelector]) => {
    document.querySelectorAll(parentSelector).forEach((parent) => {
      parent.querySelectorAll(itemSelector).forEach((item, index) => {
        item.style.setProperty('--reveal-delay', `${Math.min(index * 55, 165)}ms`);
        revealItems.add(item);
      });
    });
  });
  document.querySelectorAll('.section-head, .footer-bottom').forEach((item) => revealItems.add(item));

  const setRevealOrigin = (item, direction) => {
    item.classList.toggle('motion-reveal--from-top', direction === 'up');
    item.classList.toggle('motion-reveal--from-bottom', direction !== 'up');
  };

  if (reduceMotion.matches || !('IntersectionObserver' in window)) {
    revealItems.forEach((item) => item.classList.add('motion-reveal', 'is-visible'));
  } else {
    let lastObserverScrollY = window.scrollY;
    const revealObserver = new IntersectionObserver((entries) => {
      const currentScrollY = window.scrollY;
      const scrollDirection = currentScrollY < lastObserverScrollY ? 'up' : 'down';
      lastObserverScrollY = currentScrollY;
      entries.forEach((entry) => {
        const item = entry.target;
        if (entry.isIntersecting && entry.intersectionRatio >= 0.08) {
          setRevealOrigin(item, scrollDirection);
          window.requestAnimationFrame(() => item.classList.add('is-visible'));
          return;
        }

        if (!entry.isIntersecting) {
          item.classList.remove('is-visible');
          const nextDirection = entry.boundingClientRect.bottom <= 0 ? 'up' : 'down';
          setRevealOrigin(item, nextDirection);
        }
      });
    }, { rootMargin: '0px', threshold: [0, 0.08] });

    revealItems.forEach((item) => {
      item.classList.add('motion-reveal');
      const rect = item.getBoundingClientRect();
      setRevealOrigin(item, rect.top < 0 ? 'up' : 'down');
      if (rect.bottom > 0 && rect.top < window.innerHeight && Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0) >= Math.min(rect.height * 0.08, 24)) {
        item.classList.add('is-visible');
      }
      revealObserver.observe(item);
    });
  }

  const loadScene = (element) => {
    if (element.dataset.sceneLoading === 'true') return;
    element.dataset.sceneLoading = 'true';
    const image = new Image();
    const show = () => {
      element.style.setProperty('--scene-image', `url("${image.src}")`);
      element.classList.add('is-scene-ready');
    };
    image.decoding = 'async';
    image.src = element.dataset.scene;
    if (image.decode) {
      image.decode().then(show).catch(() => {
        if (image.complete && image.naturalWidth) show();
        else image.addEventListener('load', show, { once: true });
      });
    } else {
      image.addEventListener('load', show, { once: true });
    }
  };

  const sceneItems = document.querySelectorAll('[data-scene]');
  if (sceneItems.length === 0) return;
  if (!('IntersectionObserver' in window)) {
    sceneItems.forEach(loadScene);
  } else {
    const sceneObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        loadScene(entry.target);
        sceneObserver.unobserve(entry.target);
      });
    }, { rootMargin: '450px 0px', threshold: 0.01 });
    sceneItems.forEach((item) => sceneObserver.observe(item));
  }
}

initialiseMotion();
